import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { storeOwnerQueries } from '@/services/storeOwner/storeOwner.queries';
import { useSearch } from '@tanstack/react-router';

export const useStoreOwner = () => {
  const { createdDate, page, fetch, q, sort } = useSearch({ from: '/(app)/users/store-owners/' });
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  const { data, isLoading } = useQuery({
    ...storeOwnerQueries.list({
      fromDate: parsedCreatedDate?.start,
      toDate: parsedCreatedDate?.end,
      search: q,
      row: page,
      fetch: fetch,
    }),
    select: (res) => {
      return {
        ...res,
        data: sortBy(res.data, sort),
      };
    },
    enabled: !!fetch,
  });

  return { data, isLoading, pagination: data?.meta?.pagination || defaultMeta };
};
